<template>
    <v-list subheader>
        <template v-if="irmao.dataDeNascimento">
            <ItemListaDetalhes
                icone="mdi-cake-variant"
                :titulo="`${ formatarData(irmao.dataDeNascimento) } (${ calcularIdade(irmao.dataDeNascimento) } anos)`"
                subtitulo="Nascimento"
            />
        </template>
        <ItemListaDetalhes
            icone="mdi-account-card-details"
            :titulo="irmao.cim"
            subtitulo="CIM"
        />
        <ItemListaDetalhes
            icone="mdi-flag"
            :titulo="irmao.situacaoDoMacon"
            subtitulo="Situação"
        />

        <v-divider inset />
        <v-subheader inset>Contato</v-subheader>

        <ItemListaDetalhes
            icone="mdi-email"
            :titulo="irmao.email ? irmao.email.toLowerCase() : 'Não informado'"
            subtitulo="E-mail"
            no-transform
            :href="irmao.email && `mailto:${irmao.email}`"
        />
        <ItemListaDetalhes
            v-for="(telefone, indice) in irmao.telefones"
            :key="indice"
            :icone="telefone.tipo === 'Celular' ? 'mdi-cellphone' : 'mdi-phone'"
            :titulo="formatarTelefone(telefone.valor)"
            :subtitulo="telefone.tipo"
            :href="`tel:${telefone.valor}`"
        >
            <template #actions>
                <v-list-item-action>
                    <v-btn icon :href="`https://api.whatsapp.com/send?phone=%2B55${telefone.valor}`">
                        <v-icon color="green"> mdi-whatsapp </v-icon>
                    </v-btn>
                </v-list-item-action>
            </template>
        </ItemListaDetalhes>
    </v-list>
</template>

<script setup lang="ts">
import ItemListaDetalhes from '@/components/ItemListaDetalhes.vue'
import { formatarData } from '@/shareds/formatadores'
import Irmao from '@/../common/types/Irmao'
import dayjs from 'dayjs';
import { formatarTelefone } from '@/shareds/formatadores'

defineProps<{ irmao: Irmao }>()

function calcularIdade(data: string) {
	return dayjs().diff(dayjs(data), 'years')
}
</script>
